export default __webpack_public_path__ + "static/media/onpitch-header.0620c8e0.svg";